export const commonShimProps = (v8Props = {}) => {
  const {
    ariaDescribedBy,
    ariaLabel,
    ariaLabelledBy,
    ariaPositionInSet,
    ariaSetSize,
  } = v8Props;

  return ({
    'aria-describedby': ariaDescribedBy,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    'aria-posinset': ariaPositionInSet,
    'aria-setsize': ariaSetSize,
  });
};
